import { z } from "zod";
import { CreateAlertConfigSchema, FrequencySchema } from "./AlertBuilderSchema";
/**
 * Only available for an existing alert
 */
const EditAlertExtraFieldsSchema = z.object({
  alertId: z.string().min(1, 'Alert ID is not provided for editing'),
  divisionId: z.string().min(1, 'Division ID is required'),
  divisionName: z.string().min(1, 'Division name is required'),
  alertFrequency: FrequencySchema.optional(), // this value must be synced from queryJSON.basicInfo.frequency at backend
  team: z.string().min(1, 'Team is required'), // computed as ${product}#${divisionId}
  version: z.number().optional(),
  createdAt: z.string().datetime(),
  createdBy: z.string(),
  updatedAt: z.string().datetime(),
  updatedBy: z.string(),
  triggeredCount: z.number(),
  expiredAt: z.string().datetime(),
  enabledFlag: z.boolean(), // not the valid state of the alert, but it is enabled or disabled state
});

/**
 * Discriminated union schema for Alert configuration with variant to distinguish between create and edit
 */
export const FormAlertConfigSchema = z.intersection(
  CreateAlertConfigSchema,
  z.discriminatedUnion('variant', [
    z.object({ variant: z.literal('create') }),
    z
      .object({
        variant: z.literal('edit')
      })
      .merge(EditAlertExtraFieldsSchema)
  ])
);

// An existing alert for editing, or a full API Alert to persist into DynamoDB
// no 'variant' field
export const FullAlertConfigSchema = CreateAlertConfigSchema.merge(EditAlertExtraFieldsSchema);
